import * as angular from 'angular';
import {IController, IOnChangesObject} from 'angular';
import * as _ from "lodash";

export class BringozItemsEditComponent implements IController {
  items: any;
  maxItemsToShow: number;
  ngPlaceholder: string;
  isRequired?: any;
  isRow?: boolean;
  name: string;
  form: any;
  onChange: Function;

  constructor(private $mdPanel) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.add-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          items: this.items || [],
          ngPlaceholder: this.ngPlaceholder,
          isRequired: this.isRequired,
          name: this.name,
          form: this.form,
          parentScope: this
        },

        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: BringozItemsEditCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./template/panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(items, parentScope) {
    parentScope.onSettingsChange({
      items: items
    })
  }
}

class BringozItemsEditCtrl implements IController {
//values from the parent
  public items: any;
  public ngPlaceholder: string;
  public isRequired: boolean;
  public name: string;
  public form: string;

  public item: string;

  constructor(private mdPanelRef) {

  }

  $onInit() {

    this.items = this.mdPanelRef.config.locals.data.items
    this.ngPlaceholder = this.mdPanelRef.config.locals.data.ngPlaceholder
    this.isRequired = this.mdPanelRef.config.locals.data.isRequired
    this.name = this.mdPanelRef.config.locals.data.name
    this.form = this.mdPanelRef.config.locals.data.form

    if (!this.name) {
      this.name = 'itemsEdit'
    }
  }

  onInputKeyPressed($event) {
    if ($event.which === 13) { // 13 === enter key

      if (!this.items?.includes(this.item) && this.item.trim() !== "") {
        if (!this.items) {
          this.items = [];
        }
        this.items = this.items.concat(this.item);
        this.mdPanelRef.config.locals.data.parentScope.onChange({items: this.items});
        this.item = undefined;
      }
    }
  }

  onItemRemove(index) {
    this.items.splice(index, 1)
    this.mdPanelRef.config.locals.data.parentScope.onChange({items: this.items});
  }

  cancel() {
    this.mdPanelRef.close();
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozItemsEdit', {
    require: {
      form: '^form'
    },
    bindings: {
      items: '<?',
      maxItemsToShow: '<?',
      ngPlaceholder: '@?',
      name: '@?',
      isRequired: '<?',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./bringoz-items-edit.html').default,
    controller: BringozItemsEditComponent
  });
